import React, { useState, Fragment } from 'react';
function Modal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" onClick={onClose} data-id="element-73">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-74" />
      <div className="relative bg-brand-dark border border-brand-gold/20 rounded-[16px] max-w-[640px] w-full max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-75">
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/[0.08]" data-id="element-76">
          <h3 className="font-display italic text-[22px] text-brand-cream" data-id="element-77">
            {title}
          </h3>
          <button onClick={onClose} className="text-brand-cream/50 hover:text-brand-gold text-[24px] transition-colors leading-none" data-id="element-78">
            &times;
          </button>
        </div>
        <div className="overflow-y-auto px-6 py-5 font-body text-[14px] text-brand-cream/70 leading-[1.8] space-y-4" data-id="element-79">
          {children}
        </div>
      </div>
    </div>;
}
function PrivacyContent() {
  return <>
      <p data-id="element-80">
        <strong className="text-brand-cream" data-id="element-81">Última actualización:</strong>{' '}
        Enero 2025
      </p>
      <p data-id="element-82">
        Esta Política de Privacidad describe cómo se recopila, utiliza y protege
        la información personal proporcionada al utilizar este sitio web y
        adquirir el producto digital RENACER: El Protocolo Cuántico.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-83">
        1. Información que recopilamos
      </h4>
      <p data-id="element-84">
        Al realizar una compra, se recopila únicamente la información necesaria
        para procesar la transacción:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-85">
        <li data-id="element-86">Dirección de correo electrónico (para envío del producto)</li>
        <li data-id="element-87">
          Información de pago (procesada de forma segura por la pasarela de
          pago, no almacenada en nuestros servidores)
        </li>
      </ul>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-88">
        2. Uso de la información
      </h4>
      <p data-id="element-89">La información recopilada se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-90">
        <li data-id="element-91">Procesar y entregar el producto digital adquirido</li>
        <li data-id="element-92">Enviar comunicaciones relacionadas con la compra</li>
        <li data-id="element-93">Brindar soporte al cliente cuando sea solicitado</li>
      </ul>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-94">
        3. Protección de datos
      </h4>
      <p data-id="element-95">
        Se implementan medidas de seguridad técnicas y organizativas para
        proteger la información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-96">
        4. Compartición de datos
      </h4>
      <p data-id="element-97">
        No se vende, intercambia ni transfiere información personal a terceros,
        excepto a proveedores de servicios necesarios para procesar pagos y
        entregar el producto.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-98">
        5. Cookies
      </h4>
      <p data-id="element-99">
        Este sitio puede utilizar cookies para mejorar la experiencia del
        usuario y con fines analíticos. Puedes desactivar las cookies en la
        configuración de tu navegador.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-100">
        6. Derechos del usuario
      </h4>
      <p data-id="element-101">
        Tienes derecho a acceder, rectificar o solicitar la eliminación de tus
        datos personales en cualquier momento contactándonos a través de los
        canales disponibles en este sitio.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-102">
        7. Cambios en esta política
      </h4>
      <p data-id="element-103">
        Esta política puede actualizarse periódicamente. Cualquier cambio será
        publicado en esta página con la fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p data-id="element-104">
        <strong className="text-brand-cream" data-id="element-105">Última actualización:</strong>{' '}
        Enero 2025
      </p>
      <p data-id="element-106">
        Al acceder a este sitio web y/o adquirir el producto digital RENACER: El
        Protocolo Cuántico, aceptas los siguientes términos y condiciones.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-107">
        1. Producto digital
      </h4>
      <p data-id="element-108">
        RENACER: El Protocolo Cuántico es un producto digital (ebook en formato
        PDF) de carácter informativo y educativo. No constituye asesoramiento
        médico, psicológico ni profesional de ningún tipo.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-109">
        2. Entrega del producto
      </h4>
      <p data-id="element-110">
        Tras confirmar el pago, recibirás un correo electrónico con el enlace de
        descarga del producto en formato PDF. La entrega es inmediata y digital.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-111">
        3. Política de reembolso
      </h4>
      <p data-id="element-112">
        Ofrecemos una garantía de satisfacción de 7 días. Si dentro de los 7
        días posteriores a la compra consideras que el producto no cumple con
        tus expectativas, puedes solicitar un reembolso completo sin preguntas
        ni complicaciones.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-113">
        4. Propiedad intelectual
      </h4>
      <p data-id="element-114">
        Todo el contenido del producto, incluyendo textos, diseños, técnicas y
        metodologías, está protegido por derechos de autor. Queda prohibida la
        reproducción, distribución o reventa total o parcial del contenido sin
        autorización expresa.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-115">
        5. Uso personal
      </h4>
      <p data-id="element-116">
        El producto adquirido es para uso personal y exclusivo del comprador. No
        está permitido compartir, redistribuir ni publicar el contenido en
        ningún medio.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-117">
        6. Limitación de responsabilidad
      </h4>
      <p data-id="element-118">
        Los resultados obtenidos al aplicar el contenido del protocolo pueden
        variar según cada persona. No se garantizan resultados específicos. El
        contenido es de naturaleza educativa e informativa.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-119">
        7. Modificaciones
      </h4>
      <p data-id="element-120">
        Estos términos pueden ser modificados en cualquier momento. Las
        modificaciones entrarán en vigor desde su publicación en esta página.
      </p>

      <h4 className="text-brand-gold text-[15px] font-medium mt-4" data-id="element-121">
        8. Aceptación
      </h4>
      <p data-id="element-122">
        Al realizar la compra del producto, confirmas que has leído, entendido y
        aceptado estos términos y condiciones en su totalidad.
      </p>
    </>;
}
export function Footer() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  const links = [{
    label: 'Inicio',
    action: () => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, {
    label: 'El Protocolo',
    action: () => document.getElementById('producto')?.scrollIntoView({
      behavior: 'smooth'
    })
  }, {
    label: 'Política de privacidad',
    action: () => setModal('privacy')
  }, {
    label: 'Términos y condiciones',
    action: () => setModal('terms')
  }];
  return <>
      <footer className="bg-brand-footer py-10 px-[5%] border-t border-white/[0.04] text-center" data-id="element-123">
        <div className="max-w-7xl mx-auto" data-id="element-124">
          <div className="font-display text-[24px] tracking-[0.15em] text-brand-cream mb-2" data-id="element-125">
            REN<span className="text-brand-gold" data-id="element-126">A</span>CER
          </div>

          <p className="font-body text-[14px] text-white/30 mb-8" data-id="element-127">
            El Protocolo Cuántico para Colapsar el Trauma
            <br data-id="element-128" />y Rediseñar tu Realidad
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-129">
            {links.map((link, i) => <Fragment key={i} data-id="element-130">
                <button onClick={link.action} className="font-body text-[13px] text-white/40 hover:text-brand-gold transition-colors" data-id="element-131">
                  {link.label}
                </button>
                {i < links.length - 1 && <span className="text-white/10" data-id="element-132">&middot;</span>}
              </Fragment>)}
          </div>

          <div className="font-body text-[12px] text-white/20" data-id="element-133">
            &copy; 2025 RENACER &middot; Todos los derechos reservados
          </div>
        </div>
      </footer>

      {modal === 'privacy' && <Modal title="Política de Privacidad" onClose={() => setModal(null)} data-id="element-134">
          <PrivacyContent data-id="element-135" />
        </Modal>}
      {modal === 'terms' && <Modal title="Términos y Condiciones" onClose={() => setModal(null)} data-id="element-136">
          <TermsContent data-id="element-137" />
        </Modal>}
    </>;
}